export class Profile {
  id = -1;
  guid = "";
  created_date = "";
  last_access_date = "";
  updated_date = "";
  data = {};
  user = "";
}
